var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17002 15C1.31941 15.0005 1.46702 14.9676 1.602 14.9035C1.73698 14.8395 1.8559 14.7461 1.95002 14.63L6.78002 8.63003C6.9271 8.4511 7.00751 8.22666 7.00751 7.99503C7.00751 7.76341 6.9271 7.53896 6.78002 7.36003L1.78002 1.36003C1.61028 1.15581 1.36637 1.02739 1.10194 1.00301C0.837517 0.978631 0.574236 1.06029 0.370019 1.23003C0.165803 1.39977 0.0373788 1.64368 0.0129991 1.90811C-0.0113807 2.17253 0.0702806 2.43581 0.240019 2.64003L4.71002 8.00003L0.39002 13.36C0.267737 13.5068 0.19006 13.6856 0.16618 13.8751C0.142301 14.0647 0.173217 14.2571 0.255273 14.4296C0.337329 14.6021 0.467089 14.7475 0.6292 14.8486C0.79131 14.9497 0.978986 15.0023 1.17002 15Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/IconArrowRight.224c90e5ecd92d264e10b4b358995366.svg";
export { ForwardRef as ReactComponent };